import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VRow,{staticClass:"fill-height",attrs:{"align-content":"center","justify":"center"}},[_c(VCol,{staticClass:"subtitle-1 text-center",attrs:{"cols":"12"}},[_vm._v(" "+_vm._s(_vm.$t(_vm.text))+" ")]),_c(VCol,{attrs:{"cols":"6"}},[_c(VProgressLinear,{attrs:{"color":"primary","indeterminate":"","rounded":"","height":"6"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }